import {Component, Input} from '@angular/core';
import {NgClass} from '@angular/common';
import {SafeHtml} from '@angular/platform-browser';

@Component({
  selector: 'app-card-campana-porcentaje-component',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './card-campana-porcentaje-component.html',
  styleUrl: './card-campana-porcentaje-component.scss'
})
export class CardCampanaPorcentajeComponent {
  @Input() titulo: string = '';
  @Input() subtitulo: string = '';
  @Input() imagen: SafeHtml | string = '';
  @Input() colorIcon: string= '';
  @Input() percentage: string = '';
}
